import * as React from 'react';
import './PreferencesAddButtonWrapper.scss';

interface PreferencesAddButtonWrapperProps {
  children: React.ReactNode;
}

/**
 * Wrapper per il pulsante di aggiunta riga
 */
export function PreferencesAddButtonWrapper(
  props: PreferencesAddButtonWrapperProps
) {
  return <div className="preferences-add-button-wrapper">{props.children}</div>;
}
